export const vehicleCategories = [
  'Standard',
  'Motorhome',
  'Rec Trailer',
  'Utility Trailer',
  'Handicapped Vehicle',
  'Pickup With Camper',
  'Van Conversion',
] as const;

export const vehicleCategoryItems = vehicleCategories.map((val) => ({
  value: val,
  label: val,
}));
